import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Table from "components/CompanyAdmin/Users/CompanyAdmin/CompanyAdmin";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyAdminCompany,
  createNewCompanyAdminCompany,
  deleteCompanyAdminCompany,
} from "store/actions/companyAdminUsers";

const CompanyAdmin = () => {
  const companyAdminData = useSelector(
    (state) => state.companyAdminUsers.companyAdmin
  );
  const dispatch = useDispatch();
  const [page, setPage] = useState(
    companyAdminData ? companyAdminData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    companyAdminData ? companyAdminData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    companyAdminData ? companyAdminData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    companyAdminData ? companyAdminData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    companyAdminData ? companyAdminData.pag.search_by : "display_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCompanyAdminCompany(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteCompanyAdminCompany(id, pag, history));
  };
  const createHandler = (newUser) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(createNewCompanyAdminCompany(newUser, pag, history));
  };
  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Company Admin Users </h4>
        </CardHeader>
        <CardBody>
          {companyAdminData && (
            <Table
              rows={companyAdminData.data}
              totalRows={companyAdminData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              deleteUser={deleteHandler}
              createUser={createHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CompanyAdmin;
